// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"161":"yearlies","178":"notfound","594":"about"}[chunkId] || chunkId) + "." + {"161":"75adfe18","178":"e435fc58","300":"f3b7ff66","594":"85d5fe5b"}[chunkId] + ".js";
};